(function ($) {
  Drupal.behaviors.blogLandingPageV2 = {
    attached: false,
    isDesktop: false,
    requestFlag: false,
    tilesToShow: 10,
    nodes: {},

    selectors: {
      blogLandingPage: '.js-blog-landing-page-v2',
      blogMenu: '.blog-landing-page__menu',
      blogMenuList: '.blog-landing-page__menu ul',
      blogMenuAll: '.js-blog-landing-page-all',
      blogFilterDropdown: '.js-blog-landing-page-filter-dropdown select',
      blogPost: '.blog-post',
      blogTilesContainer: '.blog-landing-page__tiles',
      blogNewTilesContainer: '.blog-landing-page__new-tiles',
      blogTileImageContainer: '.blog-post-tile__landing-image',
      blogTileImageSmall: '.js-blog-post-tile__landing-image-standard',
      blogTileImageFeatured: '.js-blog-post-tile__landing-image-featured',
      blogLoadMoreButton: '.blog-landing-page__load-more'
    },

    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.updateIsDesktop();

      $(self.selectors.blogLandingPage, context).each(function () {
        self.setup($(this));
      });
    },

    setup: function ($that) {
      var self = this;

      self.getDom($that);
      self.setEvents($that);
      self.init($that);
    },

    getDom: function ($that) {
      var self = this;
      var path = window.location.pathname.split('/').slice(0, 3).join('/');

      $that.nodes = {};
      $that.nodes.$blogMenu =
        $(self.selectors.blogMenu, $that);
      $that.nodes.$blogMenuActive =
        $that.nodes.$blogMenu.find('a[href="' + path + '"]');
      $that.nodes.$blogMenuList =
        $(self.selectors.blogMenuList, $that);
      $that.nodes.$blogMenuAll =
        $(self.selectors.blogMenuAll, $that.nodes.$blogMenu);
      $that.nodes.$blogFilterDropdown =
        $(self.selectors.blogFilterDropdown, $that);
      $that.nodes.$blogPost =
        $(self.selectors.blogPost, $that);
      $that.nodes.$blogTilesContainer =
        $(self.selectors.blogTilesContainer, $that);
      $that.nodes.$blogNewTilesContainer =
        $(self.selectors.blogNewTilesContainer, $that);
      $that.nodes.$blogTileImageContainer =
        $(self.selectors.blogTileImageContainer, $that.nodes.$blogPost);
      $that.nodes.$blogTileImageSmall =
        $(self.selectors.blogTileImageSmall, $that.nodes.$blogPost);
      $that.nodes.$blogTileImageFeatured =
        $(self.selectors.blogTileImageFeatured, $that.nodes.$blogPost);
      $that.nodes.$blogLoadMoreButton =
        $(self.selectors.blogLoadMoreButton, $that);
    },

    setEvents: function ($that) {
      var self = this;

      $(window).on(
        'resize',
        _.debounce(function () {
          self.updateIsDesktop();
          self.resetFeaturedPost($that);
          self.featuredDesktopPost($that);
        }, 100)
      );

      $that.nodes.$blogLoadMoreButton.once().on('click', function (e) {
        self.loadMoreRequest($that, e);
      });
    },

    init: function ($that) {
      var self = this;

      self.menuLinkUpdates($that);
      self.featuredDesktopPost($that);
      self.initializejQueryObjects($that);
      self.buildGridTile($that.nodes.$blogPost);

      $that.nodes.$blogFilterDropdown.find('option').first().text($that.nodes.$blogMenuActive.text());
      $that.nodes.$blogFilterDropdown.val(window.location.pathname);
      $that.nodes.$blogFilterDropdown.selectbox({
        onChange: function (targetLocation) {
          location.replace(targetLocation);
        },
        keepInViewport: true
      });
    },

    updateIsDesktop: function () {
      var self = this;
      var bps = Unison.fetch.all();
      var bp = Unison.fetch.now();

      self.isDesktop = parseInt(bp.width, 10) >= parseInt(bps['usn-medium-max'], 10);
    },

    initializejQueryObjects: function ($that) {
      var self = this;

      self.setParams();
      self.requestFlag = true;

      self.tilesCounter($that);
      self.featuredPost($that);
      self.hideLastPost($that);
      self.hideLoadMoreBtn($that);
    },

    loadMoreRequest: function ($that, e) {
      var self = this;

      e.preventDefault();

      if (self.requestFlag === false) {
        return false;
      }

      self.requestFlag = false;

      var url = `/elc_api/blog/${self.catBlog}/${self.termBlog}/10/${self.tilesInContainer}`;

      jQuery
        .ajax({
          url: url,
          type: 'GET',
          dataType: 'html'
        })
        .done(function (response) {
          self.updateTilesContainer($that, response);
        })
        .always(function () {
          self.requestFlag = true;
        });
    },

    updateTilesContainer: function ($that, response) {
      var self = this;
      var $blogPost = $();
      var parseTiles = JSON.parse(response);
      var tiles = Object.keys(parseTiles).map(function (data) {
        return parseTiles[data];
      });

      tiles.map(function (tile) {
        return $that.nodes.$blogNewTilesContainer.append(tile.rendered);
      });
      $blogPost = $('.blog-post', $that.nodes.$blogNewTilesContainer);
      self.buildGridTile($blogPost);
      $that.nodes.$blogTilesContainer.append($that.nodes.$blogNewTilesContainer.contents());
      self.hideLoadMoreBtn($that, tiles);
      self.tilesCounter($that);
      self.processClickableElements($that);
    },

    setParams: function () {
      var self = this;
      var URLParameters = self.getURLParams();

      self.catBlog = URLParameters[1] ? URLParameters[1] : 'all';
      self.termBlog = 'all';
    },

    hideLoadMoreBtn: function ($that, tiles) {
      var self = this;

      if (
        (self.tilesInContainer < self.tilesToShow - 1 && self.featuredPost) ||
        (self.tilesInContainer < self.tilesToShow && !self.featuredPost) ||
        (typeof tiles !== 'undefined' && tiles.length < self.tilesToShow)
      ) {
        $that.nodes.$blogLoadMoreButton.hide('fast');
      }
    },

    featuredPost: function ($that) {
      var self = this;

      self.featuredPost = false;

      if ($that.nodes.$blogTilesContainer.find('article').hasClass('blog-post--display-featured')) {
        self.featuredPost = true;
      }
    },

    hideLastPost: function ($that) {
      var self = this;

      if (self.tilesInContainer === self.tilesToShow && self.featuredPost) {
        $that.nodes.$blogTilesContainer.find('article').last().remove();
        self.tilesCounter($that);
      }
    },

    tilesCounter: function ($that) {
      var self = this;
      var tiles = $that.nodes.$blogTilesContainer.find('article');

      self.tilesInContainer = tiles.length;
    },

    getURLParams: function () {
      const params = [];
      const URLParams = $(location).attr('pathname');

      URLParams.split('/')
        .filter(function (hash) {
          return hash !== '';
        })
        .map(function (hash) {
          return params.push(hash);
        });

      return params;
    },

    buildGridTile: function ($blogPost) {
      var self = this;
      var index = 1;
      const totalPosts = $blogPost.length;

      while (index <= totalPosts) {
        if (self.isDesktop) {
          var start = index;
          var end = start + 4;

          if (end <= $blogPost.length) {
            $blogPost.slice(start, end).wrapAll('<article class="blog-post blog-post-grid"></article>');
          }
          index = start % (5) === 0 ? end + 2 : end;
        } else {
          $blogPost.slice(index, index + 2).wrapAll('<article class="blog-post blog-post-grid"></article>');
          index += 3;
        }
      }
    },

    transformListItemToOption: function (listItem) {
      var self = this;
      var text = $(listItem).text();
      var optionValue = $(listItem).attr('href');
      var $option = $('<option />');

      $option.val(optionValue);
      $option.text(text);

      if (self.isOptionSelected(optionValue)) {
        $option.attr('selected', true);
      }

      return $option;
    },

    isOptionSelected: function (currentVal) {
      var pathname = $(location).attr('pathname');

      return currentVal === pathname;
    },

    featuredDesktopPost: function ($that) {
      var self = this;

      if (self.isDesktop) {
        if (
          $that.nodes.$blogPost.length &&
          $that.nodes.$blogTileImageSmall.length &&
          $that.nodes.$blogTileImageFeatured.length
        ) {
          $that.nodes.$blogPost.first().addClass('blog-post--display-featured');
          $that.nodes.$blogTileImageFeatured.first().removeClass('blog-landing-hidden');
          $that.nodes.$blogTileImageSmall.first().addClass('blog-landing-hidden');
        }
      }
    },

    resetFeaturedPost: function ($that) {
      if (
        $that.nodes.$blogPost.length &&
        $that.nodes.$blogTileImageSmall.length &&
        $that.nodes.$blogTileImageFeatured.length
      ) {
        $that.nodes.$blogPost.first().removeClass('blog-post--display-featured');
        $that.nodes.$blogTileImageFeatured.first().addClass('blog-landing-hidden');
        $that.nodes.$blogTileImageSmall.removeClass('blog-landing-hidden');
      }
    },

    menuLinkUpdates: function ($that) {
      if ($that.nodes.$blogMenu.length && $that.nodes.$blogMenuActive.length) {
        $that.nodes.$blogMenuActive.addClass('active');
        $that.nodes.$blogMenuActive[0].scrollIntoView({
          behaviour: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    },

    processClickableElements: function ($that) {
      var $unprocessedClickableTiles = $that.nodes.$blogTilesContainer.find(('[data-clickable]:not(.clickable-processed)'));

      $unprocessedClickableTiles.addClass('clickable-processed block--linked')
        .once('clickable').on('click', function () {
          if (window.location.hash) {
            history.replaceState('', '', $(this).data('clickable'));
          }
          window.location.href = $(this).data('clickable');
        });
    }
  };
})(jQuery);
